import { SagaIterator } from 'redux-saga';
import { Project } from 'src/modules/common/types/Project';
import { loadProjectListFull } from 'src/modules/project-list/sagas/utils/loadProjectListFull';
import { call } from 'typed-redux-saga';

export function* getProjectCopyName(project: Project): SagaIterator<string> {
  const projects = yield* call(loadProjectListFull);

  const prefix = /\S\s+\d+$/.test(project.data.title)
    ? project.data.title.replace(/\s+\d+$/, '')
    : project.data.title;
  const number = projects.reduce((max, other) => {
    if (!other.data.title.startsWith(prefix)) {
      return max;
    }

    const suffix = other.data.title.substring(prefix.length);
    if (!/^\s+\d+$/.test(suffix)) {
      return max;
    }

    const copyNumber = parseInt(suffix.trim(), 10);
    return Math.max(max, copyNumber + 1);
  }, 1);

  return `${prefix} ${number}`;
}
